import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import AvatarGroup from 'react-avatar-group';
import { startCase } from 'lodash';

const TestimonialText = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: ${(props) => props.fW || 400};
  font-size: ${(props) => props.fS || '20px'};
  line-height: 120%;
  color: ${(props) => props.color || '#000000'};
  display: flex;
  align-items: ${(props) => props.alignSef || 'center'};
  gap: 5px;
`;

const TestimonialBody = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: ${(props) => props.borderBottom && '1px solid #d9d9d9'};
  padding-bottom: 10px;
  flex: 1;
`;

const TestimonialContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const TestimonialImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
`;

const TestimonialContentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  /* margin-top: 10px; */
`;

const TestimonialReactions = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const QuoteIcon = () => {
  return (
    <svg width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.59502 2.292C4.23881 0.771 6.72616 0 9.98679 0H11.1584V2.819L10.2164 2.98C8.6113 3.254 7.49475 3.793 6.89722 4.584C6.58544 5.01013 6.40862 5.49804 6.38405 6H9.98679C10.2975 6 10.5955 6.10536 10.8152 6.29289C11.035 6.48043 11.1584 6.73478 11.1584 7V14C11.1584 15.103 10.1075 16 8.81516 16H1.78543C1.4747 16 1.17669 15.8946 0.956972 15.7071C0.737251 15.5196 0.613812 15.2652 0.613812 15V10L0.617327 7.081C0.606783 6.97 0.384174 4.34 2.59502 2.292ZM21.703 16H14.6733C14.3625 16 14.0645 15.8946 13.8448 15.7071C13.6251 15.5196 13.5017 15.2652 13.5017 15V10L13.5052 7.081C13.4946 6.97 13.272 4.34 15.4829 2.292C17.1266 0.771 19.614 0 22.8746 0H24.0462V2.819L23.1043 2.98C21.4991 3.254 20.3826 3.793 19.7851 4.584C19.4733 5.01013 19.2965 5.49804 19.2719 6H22.8746C23.1854 6 23.4834 6.10536 23.7031 6.29289C23.9228 6.48043 24.0462 6.73478 24.0462 7V14C24.0462 15.103 22.9953 16 21.703 16Z"
        fill="#5B5B5B"
      />
    </svg>
  );
};

const HandshakeIcon = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 5.80456C17.9381 6.1278 17.8952 6.4613 17.819 6.77941C17.614 7.59521 17.2328 8.31352 16.6514 8.98052C16.6085 8.90869 16.5847 8.84199 16.537 8.79068C15.0311 7.077 13.53 5.35818 12.0241 3.64449C11.5476 3.10062 10.9996 3.0801 10.4944 3.59318C9.72717 4.37306 8.96469 5.15295 8.19269 5.9277C7.69708 6.42538 6.98702 6.4613 6.47711 6.04057C6.19118 5.80456 6.07205 5.49671 6.17212 5.18886C6.21025 5.06572 6.28173 4.94258 6.37227 4.85536C7.50169 3.6958 8.61681 2.51571 9.77959 1.40233C11.2045 0.0324058 12.8724 -0.321619 14.6737 0.319731C16.437 0.950819 17.4711 2.3464 17.8904 4.28071C17.9381 4.50133 17.9619 4.73222 18 4.95797C18 5.24017 18 5.52236 18 5.80456Z"
        fill="#6BBB84"
      />
      <path
        d="M9.83197 13.4854C9.92251 12.2232 9.36495 11.5819 8.04491 11.4074C7.97343 9.97594 7.47782 9.40642 6.25309 9.3705C6.2388 9.16527 6.24833 8.94978 6.21497 8.74968C5.9767 7.40028 4.4994 6.84615 3.54154 7.75943C3.01733 8.26225 2.51696 8.79585 2.00229 9.31406C1.9451 9.3705 1.89268 9.42694 1.83073 9.48851C0.353432 8.01597 -0.323266 6.23558 0.148516 4.10117C0.610768 2.00781 1.87362 0.663535 3.8084 0.160717C5.62405 -0.311317 7.20142 0.273594 8.54052 1.6897C8.21171 2.02833 7.89718 2.34644 7.58266 2.66455C7.04893 3.20841 6.5152 3.74715 5.98623 4.29101C5.26664 5.02472 5.34765 6.04061 6.16732 6.64605C6.94885 7.2207 7.94484 7.12834 8.65966 6.41003C9.39831 5.66607 10.1322 4.91184 10.8708 4.16787C10.9042 4.13196 10.9423 4.09604 10.9757 4.06526C11.1806 3.86515 11.3331 3.87029 11.5285 4.09091C11.8144 4.40902 12.0956 4.73226 12.3767 5.0555C13.6682 6.52804 14.9596 8.00571 16.2511 9.47825C16.3607 9.60652 16.4846 9.7194 16.5942 9.84254C16.9945 10.2889 17.0469 10.9046 16.7181 11.3459C16.3368 11.8589 15.6459 11.8897 15.2122 11.3972C14.5736 10.6789 13.9446 9.95028 13.3108 9.23197C12.5531 8.37 11.8001 7.50802 11.0424 6.64605C10.9995 6.59474 10.9519 6.5383 10.8994 6.50239C10.766 6.39977 10.6278 6.41516 10.5039 6.52291C10.3848 6.63066 10.3609 6.81537 10.4467 6.95903C10.4801 7.01547 10.5277 7.06677 10.5754 7.11808C11.9526 8.68811 13.3298 10.2633 14.7071 11.8333C15.2551 12.4592 15.0645 13.3879 14.3401 13.6342C13.9112 13.7779 13.5586 13.6342 13.2583 13.2904C12.5245 12.449 11.7858 11.6127 11.0519 10.7712C10.4038 10.0324 9.76049 9.29867 9.11238 8.55984C9.07902 8.52392 9.05043 8.48287 9.01231 8.45209C8.88364 8.33408 8.70732 8.33921 8.58818 8.45722C8.46904 8.5701 8.44998 8.76507 8.54529 8.91386C8.58341 8.9703 8.63107 9.02161 8.67872 9.07292C10.0607 10.6481 11.4427 12.2232 12.8247 13.8035C13.1297 14.1524 13.2059 14.6039 13.0296 15.0093C12.858 15.4043 12.4911 15.6455 12.0765 15.625C12.0098 15.6198 11.9478 15.6044 11.8811 15.5942C11.7096 15.5634 11.6333 15.4813 11.6381 15.2658C11.6619 14.2704 10.928 13.4905 10.0083 13.5008C9.95111 13.4854 9.89869 13.4854 9.83197 13.4854Z"
        fill="#6BBB84"
      />
      <path
        d="M9.2079 13.1313C9.20314 13.4853 9.10783 13.7419 8.90768 13.9471C8.34535 14.5218 7.78779 15.0964 7.21593 15.6608C6.8061 16.061 6.20089 16.0354 5.83395 15.6146C5.45747 15.1888 5.46224 14.532 5.8673 14.1113C6.42486 13.5315 6.98243 12.9569 7.55428 12.3976C7.86881 12.0898 8.24528 12.0282 8.63605 12.2232C9.01252 12.413 9.18408 12.7516 9.2079 13.1313Z"
        fill="#6BBB84"
      />
      <path
        d="M10.9995 15.235C11.0043 15.548 10.8947 15.8097 10.6898 16.0252C10.137 16.5896 9.58894 17.154 9.02662 17.7132C8.61202 18.1237 8.0068 18.1032 7.63033 17.6773C7.24909 17.2463 7.26339 16.5896 7.67322 16.1637C8.22125 15.5942 8.77404 15.0298 9.33161 14.4757C9.65089 14.1576 10.0226 14.096 10.4229 14.2807C10.7851 14.4398 10.9995 14.8143 10.9995 15.235Z"
        fill="#6BBB84"
      />
      <path
        d="M5.60015 8.99589C5.60015 9.37044 5.50961 9.62185 5.31899 9.82195C4.7519 10.4069 4.1848 10.9918 3.60818 11.5613C3.19835 11.9615 2.59313 11.9256 2.22619 11.4997C1.84972 11.0687 1.85925 10.4171 2.26432 9.9964C2.82188 9.41662 3.37944 8.84197 3.9513 8.28271C4.26105 7.97999 4.62799 7.91842 5.014 8.10313C5.4 8.28784 5.58585 8.62648 5.60015 8.99589Z"
        fill="#6BBB84"
      />
      <path
        d="M3.76562 12.9005C3.76562 12.5106 3.8657 12.254 4.06108 12.0539C4.62341 11.4793 5.18097 10.9046 5.75283 10.3402C6.15313 9.94002 6.76311 9.98107 7.13482 10.4069C7.50176 10.8276 7.50176 11.4741 7.11099 11.8795C6.55343 12.4644 5.98634 13.0442 5.40972 13.6085C5.09519 13.9164 4.71872 13.978 4.33272 13.7779C3.96101 13.588 3.77992 13.2545 3.76562 12.9005Z"
        fill="#6BBB84"
      />
    </svg>
  );
};

const TestimonialBox = ({
  giverName,
  giverProfilePic,
  giverPosition,
  message,
  createdAt,
  agreedUserCount,
  agreedUsers,
}) => {
  return (
    <TestimonialBody>
      <TestimonialImage src={giverProfilePic} alt="" />
      <TestimonialContent>
        <TestimonialContentHeader>
          <TestimonialText fW={500} fS="15px">
            {giverName}
          </TestimonialText>
        </TestimonialContentHeader>

        <TestimonialText fW={500} fS="12px" color="#747474" className="mt-1">
          {giverPosition || 'Account Executive, Client Services & Recruiting'}
        </TestimonialText>

        <div className="d-flex align-items-center gap-2">
          <QuoteIcon />
          <TestimonialText fS="12px" color="#5B5B5B" alignSef="flex-start" className="mt-2">
            {message}
          </TestimonialText>
        </div>

        <TestimonialText fW={500} fS="10px" color="#747474" className="pt-2">
          {moment(createdAt).format('MMM DD, YYYY')}
        </TestimonialText>

        {agreedUserCount < 0 && (
          <TestimonialReactions className="mt-1">
            <HandshakeIcon />
            <AvatarGroup
              avatars={agreedUsers?.map((e) => startCase(e.first_name))}
              // avatars={['sola', 'daves']}
              initialCharacters={1}
              max={3}
              size={22}
              shadow={0}
              displayAllOnHover={false}
              // style={{ flex: 'auto' }}
            />
            <div style={{ flex: '10', display: 'flex', alignItems: 'center' }}>
              <TestimonialText fS="10px" color="#5B5B5B">
                {agreedUserCount > 3 && `+${agreedUserCount}`} agreed with {giverName}
              </TestimonialText>
            </div>
          </TestimonialReactions>
        )}
      </TestimonialContent>
    </TestimonialBody>
  );
};

export default TestimonialBox;
